module.exports = __webpack_public_path__ + "img/pytagoras.e01f4592.svg";